<script>
  import debounce from 'lodash/debounce'
  import {getParentFrame, setParentFrameHeight} from './scripts/iframe-resizer.js'

  export let fullHeight = true
  export let colorFill = 'var(--color-white)'
  export let colorBorder = 'var(--color-blue-light-5)'
  export let overflow = 'auto'
  export let noPadding = false
  export let borderWidth = '5px'

  let iframe = getParentFrame()

  let windowWidth
  let windowHeight
  // watch changes in window size // this takes care of browser resizing
  $: on_window_resize_w = windowWidth
  // handle changes
  $: on_window_resize_w, handleResize()

  let appHeight
  // watch changes in app size // this handles changes in app dimensions (i.e. after loading content)
  $: on_app_resize_h = appHeight
  // handle changes
  $: on_app_resize_h, handleResize()


  const handleResize = debounce(e => {
    iframeMediaQuery()
    setTimeout(()=>{
      console.log('resize', windowWidth, windowHeight, appHeight, windowHeight == appHeight ? '✅ SAME' : '💢 DIFF')
      setParentFrameHeight( iframe, appHeight )
    }, 300);
  }, 100)


  let bodyMinWidthInEms;

  /* Taken from public/external/zozo-tabs/iframe-media-query.js */
  function iframeMediaQuery(){
    var target = parent.document.body

    var widthPx = target.clientWidth
    var widthEm = widthPx / parseFloat( getComputedStyle(target)['font-size'] )


    if( widthEm >= 80.5 ){ bodyMinWidthInEms = '83em' } else
    if( widthEm >= 57.9 ){ bodyMinWidthInEms = '60em' } else
    if( widthEm >= 42.0 ){ bodyMinWidthInEms = '44em' } else
    if( widthEm >= 33.0 ){ bodyMinWidthInEms = '33em' } else
    bodyMinWidthInEms = ''
  }

</script>

<svelte:window bind:innerWidth={windowWidth} bind:innerHeight={windowHeight}/>
<!-- NOPE: <svelte:body data-min-width={bodyMinWidthInEms}/> -->

<main 
  bind:offsetHeight={appHeight}
  data-min-width={bodyMinWidthInEms}
  class:fullHeight
  class:noPadding
  style="
    --color-fill: { colorFill };
    --color-border: { colorBorder };
    --overflow: { overflow };
    --border-width: { borderWidth };
  "
  >
  <slot/>
</main>

<style>
  :global(body),
  :global(html){
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    overflow: hidden; /* without, some viewport widths might trigger a vertical scrollbar, resulting in infinite calls to handleResize */
  }

  main {
    position: relative;

    padding: 10px;
    background-color: var(--color-fill);
    border: solid var(--color-border);
    border-width: var(--border-width);

    box-sizing: border-box; /* needed for 100% .fullheight to prevent vertical scroll bar */

    overflow: var(--overflow);
  }

  main.fullHeight {
    min-height: 100%;
  }

  main.noPadding {
    padding: 0;
  }
</style>
